import {Component, ElementRef, OnInit, ViewChild, Renderer2} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Appuntamento} from "../../models/appuntamento";
import {PrenotazioneAppuntamentoService} from "../../services/prenotazione-appuntamento.service";
import {ServizioErogato} from "../../models/servizio-erogato";
import {JoyrideService} from 'ngx-joyride';
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {UserData} from "../../models/user-data";
import {AlertService} from "../../shared/alert/alert.service";
import {format, zonedTimeToUtc} from "date-fns-tz";
import {parse} from "date-fns";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {AppuntamentoNew} from "../../models/appuntamento-new";
import {Employee} from "../../models/employee";
import {Configurazione} from "../../models/configurazione";
import {filter} from "rxjs/operators";
import {take} from "rxjs";
import {ConfigurazioneGeneraleService} from "../../services/configurazione-generale.service";
import {FormBuilder, Validators} from "@angular/forms";
import {RatingService} from "../../services/rating.service";
import {Toolbar} from "../../models/toolbar";
import { AmministrazioneService } from '../../services/amministrazione.service';

@Component({
  selector: 'jhi-riepilogo-prenotazione-admin',
  templateUrl: './riepilogo-prenotazione.component.html',
  styleUrls: ['./riepilogo-prenotazione.component.scss']
})
export class RiepilogoPrenotazioneComponent extends SubscriptionManager implements OnInit {
  @ViewChild('_MD_SUCCESS') _md_success!: ElementRef;
  @ViewChild('_MD_ERROR') _md_error!: ElementRef;

  appuntamento!: Appuntamento;
  selectedLanguage: string = this.translateService.currentLang;
  convDateApp!: Date;
  convDateDic!: Date;
  convDateRic!: Date;
  convTime!: Date;
  codiceServizio: string | null = null;
  ufficio: string | null = null;
  servzioErogatoScelto!: ServizioErogato;
  circleLoading = false;
  idOperatoriCompatibili!: number[];
  userData: UserData = JSON.parse(localStorage.getItem('userData') ?? '{}');
  templateCode = '';
  configurazione!: Configurazione;
  selectedRating = 0;
  questionText = '';
  choices: string[] = [];
  inTextAreaPhase = false; // Aggiunto
  serviziToolbar: Toolbar[] = [];
  idServizioAmm!: string;
  idServizio!: string;
  feedbackInviato = false;

  ratingForm = this.fb.group({
    valutazione: [this.fb.control<number | null>(null), Validators.required],
    primaRisposta: [this.fb.control<number | null>(null)],
    secondaRisposta: [this.fb.control<number | null>(null)],
    pnServizio: this.fb.group({
      id: ['', Validators.required]
    }),
    note: [''],
  })

  constructor(private ratingService: RatingService, private confService: ConfigurazioneGeneraleService, private joyrideService: JoyrideService, public route: Router, private activatedRoute: ActivatedRoute, private prenotazioneService: PrenotazioneAppuntamentoService, private translateService: TranslateService, private alertService: AlertService, private fb: FormBuilder, private ammService: AmministrazioneService) {
    super();
  }

   ngOnInit(): void {
     this.codiceServizio = this.activatedRoute.snapshot.queryParams["servizio"];
     this.ufficio = this.activatedRoute.snapshot.queryParams["ufficio"];
     window.scrollTo(0, 200);
     this.ammService.getIdByNmServizio("Appuntamenti").pipe(take(1)).subscribe({
       next: (res) => {
         this.idServizioAmm = res;
         this.ratingForm.patchValue({
           pnServizio: {
             id: this.idServizioAmm,
           }
         })
       }
     })
     this.confService.configurazione$
       .pipe(filter(configurazione => configurazione !== null), take(1))
       .subscribe(configurazione => {
         this.configurazione = configurazione!;
       });
    if (localStorage.getItem('app') != undefined && localStorage.getItem('app_op') != undefined) {
      this.circleLoading = true;

      this.idOperatoriCompatibili = JSON.parse(localStorage.getItem('app_op') || '{}');
      this.appuntamento = JSON.parse(localStorage.getItem('app') || '{}');

      if (this.controlloDatiAppuntamento(this.appuntamento)) {

        this.subs.sink = this.prenotazioneService.getServizioErogatoById(<string>this.appuntamento.idServizioErogato).subscribe({
          next: (servErog) => {
            this.servzioErogatoScelto = servErog;
          },
          complete: () => this.circleLoading = false
        });
      } else {
         void this.route.navigate(['home']);
      }

      if (this.appuntamento.dataApp != undefined)
        this.convDateApp = zonedTimeToUtc(this.appuntamento.dataApp,'Europe/Rome');

      if (this.appuntamento.dichiarante?.dataDiNascita != undefined)
        this.convDateDic = zonedTimeToUtc(parse(this.appuntamento.dichiarante.dataDiNascita.toString(), "yyyy-MM-dd", new Date()), 'Europe/Rome');

      if (this.appuntamento.richiedente !== null && this.appuntamento.richiedente?.dataDiNascita != undefined)
        this.convDateRic = zonedTimeToUtc(parse(this.appuntamento.richiedente.dataDiNascita.toString(), "yyyy-MM-dd", new Date()),'Europe/Rome');

      if (this.appuntamento.oraInizio != undefined)
        this.convTime = new Date(2023, 1, 1, parseInt(this.appuntamento.oraInizio.split(':')[0], 10), parseInt(this.appuntamento.oraInizio.split(':')[1], 10));

    } else {

      if (this.prenotazioneService.callerPage != undefined) {
        this.route.navigate([this.prenotazioneService.callerPage]).catch(() => {
         void this.route.navigate(['home'])
        })
      } else {
        void this.route.navigate(['home'])
      }
    }

    this.subs.sink = this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.selectedLanguage = langChangeEvent.lang
    });
     this.subs.sink = this.ratingForm.controls['valutazione'].valueChanges.subscribe({
       next: () =>{
         this.ratingService.selectedChoiceIndex = -1;
         this.ratingForm.patchValue({
           primaRisposta: null,
           secondaRisposta: null,
         })
       }
     });
  }

   goToSceltaDataOraPrenotazione(): void {
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/scelta-data-ora-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }else{
      void this.route.navigate(['Appuntamenti/scelta-data-ora-prenotazione'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }
  }



   goToAppuntamenti(): void {
    void this.route.navigate(['Appuntamenti/lista-prenotazioni'], {state: {previousRoute: 'prenotaNuovoAppuntamento'}})
  }

  goToServizi():void{
    window.location.href = this.confService.configurazione.linkServizi;
  }

  goToHome():void{
    window.location.href = this.confService.configurazione.linkHome;
  }

  checkListaPrenotazioni():boolean{
    return <boolean>window.history.state.isListaPrenotazioni;
  }

  inviaAppuntamento(): void {
    this.circleLoading = true;
    window.scrollTo(0, 0);


    const appuntamentoSend: AppuntamentoNew = {
      hhInizio: this.appuntamento.oraInizio,
      hhFine: this.appuntamento.oraFine,
      dataPrenotazione: this.appuntamento.dataApp,
      email: this.appuntamento.email,
      tel: this.appuntamento.tel,
      servizioErogato:{
        id: this.servzioErogatoScelto.id
      },
      flScelto: this.appuntamento.flScelto,
    }

    if(appuntamentoSend.flScelto === 'S')
      {appuntamentoSend.idDipendente = (this.appuntamento.operatore as Employee).id}

    if(this.appuntamento.richiedente?.id !== this.appuntamento.dichiarante?.id)
      {appuntamentoSend.dichiarante = this.appuntamento.dichiarante;}

    if(this.appuntamento.note && this.appuntamento.note != "")
      {appuntamentoSend.deNote = this.appuntamento.note;}

    this.subs.sink = this.prenotazioneService.insertNuovoAppuntamento(appuntamentoSend).subscribe({
      next:()=>{
        this._md_success.nativeElement.click();
        localStorage.removeItem('app');
        localStorage.removeItem('app_op');
        this.circleLoading = false;
      },
      error: () => {
        this._md_error.nativeElement.click();
        localStorage.removeItem('app');
        localStorage.removeItem('app_op');
        this.circleLoading = false;
      },
    })
  }

  onTour(): any {
    this.joyrideService.startTour({
      steps: ['primoStep', 'secondoStep']
    })
  }

  onRatingSelected(rating: number): void {
    this.selectedRating = rating;
    this.ratingForm.get('valutazione')?.setValue(rating)
    if (this.selectedRating <= 3) {
      this.questionText = "Dove hai incontrato le maggiori difficoltà?";
      this.choices = ["A volte le indicazioni non erano chiare", "A volte le indicazioni non erano complete", "A volte non capivo se stavo procedendo correttamente", "Ho avuto problemi tecnici", "Altro"];
    } else {
      this.questionText = "Quali sono stati gli aspetti che hai preferito?";
      this.choices = ["Le indicazioni erano chiare", "Le indicazioni erano complete", "Capivo sempre che stavo procedendo correttamente", "Non ho avuto problemi tecnici", "Altro"];
    }
    this.inTextAreaPhase = false;
  }

  submitQuestion(): void {
    this.circleLoading = true;
    this.subs.sink = this.ratingService.salvaFeedback(this.ratingForm.value).subscribe({
      error: (err) => {
        this.feedbackInviato = false;
        this.circleLoading = false;
        this.alertService.creaAlert(err.error.messaggio, 'danger', "sticky", 5000, true);
      },
      complete: () => {
        this.feedbackInviato = true;
        this.circleLoading = false;
        this.alertService.creaAlert('Feedback inviato con successo.', "success", "sticky", 5000, true);
      }
    });
  }

  showTextArea(): void {
    this.inTextAreaPhase = true; // Abilita la fase del campo di testo libero
  }

  backToChoices(): void {
    if (this.inTextAreaPhase) {
      this.inTextAreaPhase = false;
    }
  }

  goToListaPrenotazioni():void{
    return void this.route.navigate(['Appuntamenti/lista-prenotazioni'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}}).then();
  }

  goToNuovoAppuntamento():void{
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/prenota-nuovo-appuntamento?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}}).then();
    }else{
      void this.route.navigate(['Appuntamenti/prenota-nuovo-appuntamento'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}}).then();
    }
  }

  goToInserimentoDatiPrenotazione(): void {
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/inserimento-dati-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }else{
      void this.route.navigate(['Appuntamenti/inserimento-dati-prenotazione'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }
  }

  goToSceltaServiziPrenotazione(): void {
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/scelta-servizi-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }else{
      void this.route.navigate(['Appuntamenti/scelta-servizi-prenotazione'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}})
    }
  }

  resetSelection(): void {
    this.ratingService.resetArray(); // Resetta l'array delle stelle tramite il servizio
    this.ratingForm.get('valutazione')?.setValue(null)
    this.selectedRating = 0;
    this.questionText = '';
    this.choices = [];
  }

  handleChoiceSelected(selectedIndex: number): void {
    if(this.selectedRating < 4){
      this.ratingForm.patchValue({
        primaRisposta: null,
        secondaRisposta: selectedIndex,
      });
    }else{
      this.ratingForm.patchValue({
        primaRisposta: selectedIndex,
        secondaRisposta: null,
      })
    }
  }

  private controlloDatiAppuntamento(appuntamento: Appuntamento): boolean {
    const appCheck = this.idOperatoriCompatibili.length >= 0 && appuntamento.dataApp !== undefined
      && appuntamento.dichiarante !== undefined && appuntamento.servizio !== undefined
      && appuntamento.oraInizio !== undefined && appuntamento.richiedente !== undefined
      && appuntamento.flScelto !== undefined && appuntamento.idServizioErogato !== undefined

    const dichiaranteCheck = true;
    if (this.appuntamento.dichiarante && appuntamento.richiedente?.id !== appuntamento.dichiarante?.id) {
      this.controllouserData(this.appuntamento.dichiarante)
    }
    return appCheck && dichiaranteCheck;
  }

  private controllouserData(userData: UserData): boolean {
    return userData.id != undefined && userData.dataDiNascita != undefined
      && userData.nome != undefined && userData.cognome != undefined
      && userData.cf != undefined
  }
}
